import React, { useState, useEffect } from 'react';
import Header from './Header';
import Sidebar from './Sidebar';
import { Toaster, toast } from 'react-hot-toast';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

export default function ContactAdmin() {

  const [updateContact, setupdateContact] = useState({})

  const getContactDtl = async()=>{
    const requestOptions = {
      method: "GET",
      redirect: "follow"
    };
    
    fetch("https://api.padampura.com/ContactUs", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if(result.status === true){
          console.log(result)
          setupdateContact(result.data)
        }else{
          alert("Please Wait...!!")
        }
      })
      .catch((error) => console.error(error));
  }

  const handleChangeUpdtContact = (e) => {
    const { name, value, type, checked } = e.target;
    setupdateContact({
      ...updateContact,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const editContact = ()=>{
    const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        const raw = JSON.stringify({
            ...updateContact
        });

        const requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: raw,
          redirect: "follow"
        };

        fetch("https://api.padampura.com/Contact_Us_InsertUpdate", requestOptions)
        .then((response) => response.json())
         .then((result) => {
             if(result.status === true){
                 console.log(result)
                 alert('Update Successfully')
             }else{
                 alert('Try Again..!!')
             }
         })
         .catch((error) => console.error(error));
  }

    useEffect(()=>{
      getContactDtl();
  },[])
  
  return (
    <div>
        <div className='container-fluid p-0'>
           <div className='row g-0'>
             <div className='col-2 side'>
                <Sidebar />
             </div>
             <div className='col-10 side2'>
                <Header />
               <div className='scroll-box'>
                 <div className='container-fluid'>
                    <div className='row mt-3'>
                      <div className='col-2 ms-auto'>
                         <div onClick={editContact} className='d-flex justify-content-center align-items-center p-1 rounded-1' style={{ width:'100%', backgroundColor:"#2C3E50", fontFamily:"Poppins", fontWeight:400, color:"#fff", cursor:"pointer" }}>Save</div>
                      </div>
                    </div>
                    <hr />
                    <div className='row mt-3'>
                      <div className='col-lg-6 col-md-6 col-sm-12'>
                         <div className='' style={{ fontFamily:'Poppins', fontSize:"13px", color:'#1f5156', fontWeight:600 }}>Contact Number</div>
                         <textarea name='Contact_PhoneNumbers' value={updateContact.Contact_PhoneNumbers} onChange={handleChangeUpdtContact} className='sercc-inpt p-1' type="number" placeholder="Contact Number" autofocus required style={{width:"100%"}} />
                      </div>
                      <div className='col-lg-6 col-md-6 col-sm-12'>
                         <div className='' style={{ fontFamily:'Poppins', fontSize:"13px", color:'#1f5156', fontWeight:600 }}>Email</div>
                         <input name='Contact_EmailIDs' value={updateContact.Contact_EmailIDs} onChange={handleChangeUpdtContact} className='sercc-inpt p-1' type="email" placeholder="Email" autofocus required style={{width:"100%"}} />
                      </div>
                      {/* <div className='col-lg-4 col-md-6 col-sm-12'>
                         <div className='' style={{ fontFamily:'Poppins', fontSize:"13px", color:'#1f5156', fontWeight:600 }}>Google Map</div>
                         <input name='Contact_GoogleEmbeddedMapLink' value={updateContact.Contact_GoogleEmbeddedMapLink} onChange={handleChangeUpdtContact} className='sercc-inpt p-1' type="url" placeholder="Email" autofocus required style={{width:"100%"}} />
                      </div> */}
                    </div>
                    <div className='row mt-3'>
                      <div className='col-lg-4 col-md-6 col-sm-12'>
                         <div className='' style={{ fontFamily:'Poppins', fontSize:"13px", color:'#1f5156', fontWeight:600 }}>Address</div>
                         <textarea name='Contact_Address' value={updateContact.Contact_Address} onChange={handleChangeUpdtContact} rows="5" className='sercc-inpt p-1' type="text" placeholder="Address" autofocus required style={{width:"100%"}} />
                      </div>
                      <div className='col-lg-4 col-md-6 col-sm-12'>
                         <div className='' style={{ fontFamily:'Poppins', fontSize:"13px", color:'#1f5156', fontWeight:600 }}>Reach Description</div>
                         <textarea name='Reach_Description' value={updateContact.Reach_Description} onChange={handleChangeUpdtContact} rows="5" className='sercc-inpt p-1' type="Reach Description" placeholder="Reach Description" autofocus required style={{width:"100%"}} />
                      </div>
                      <div className='col-lg-4 col-md-6 col-sm-12'>
                         <div className='' style={{ fontFamily:'Poppins', fontSize:"13px", color:'#1f5156', fontWeight:600 }}>Road Description</div>
                         <textarea name='Reach_RoadDesc' value={updateContact.Reach_RoadDesc} rows="5" onChange={handleChangeUpdtContact}  className='sercc-inpt p-1' type="text" placeholder="Road Description" autofocus required style={{width:"100%"}} />
                      </div>
                    </div>
                    <div className='row mt-3'>
                      <div className='col-lg-4 col-md-6 col-sm-12'>
                         <div className='' style={{ fontFamily:'Poppins', fontSize:"13px", color:'#1f5156', fontWeight:600 }}>Rail Description</div>
                         <textarea name='Reach_RailDesc' value={updateContact.Reach_RailDesc} onChange={handleChangeUpdtContact} rows="5" className='sercc-inpt p-1' type="text" placeholder="Rail Description" autofocus required style={{width:"100%"}} />
                      </div>
                      <div className='col-lg-4 col-md-6 col-sm-12'>
                         <div className='' style={{ fontFamily:'Poppins', fontSize:"13px", color:'#1f5156', fontWeight:600 }}>Air Description</div>
                         <textarea name='Reach_AirDesc' value={updateContact.Reach_AirDesc} onChange={handleChangeUpdtContact} rows="5" className='sercc-inpt p-1' type="Air Description" placeholder="Reach Description" autofocus required style={{width:"100%"}} />
                      </div>
                      <div className='col-lg-4 col-md-6 col-sm-12'>
                         <div className='' style={{ fontFamily:'Poppins', fontSize:"13px", color:'#1f5156', fontWeight:600 }}>Nearby Description</div>
                         <textarea name='NearbyDesc' value={updateContact.NearbyDesc} onChange={handleChangeUpdtContact} rows="5" className='sercc-inpt p-1' type="text" placeholder="Nearby Description" autofocus required style={{width:"100%"}} />
                      </div>
                    </div>
                 </div>
               </div>
             </div>
           </div>
        </div>
    </div>
  )
}
